import { WeekDay } from 'src/app/api/contracts/menu';

export const WEEK_DAYS: WeekDay[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
];
